module.exports = __webpack_public_path__ + "static/media/Huda_logo1.a9c85f38.png";